import actions from './actions';

const initState = {
    paymentInfo: {},
    payments   : {
        data: []
    },
    loading : false,
};

export default function fetchPaymentsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_PAYMENTS_REQUESTED:
            return {
                ...state,
                payments   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_PAYMENTS_SUCCEEDED:
            return {
                ...state,
                payments    : action.payments,
                loading     : false
            };
        case actions.FETCH_PAYMENTS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_PAYMENT_REQUESTED:
            return {
                ...state,
                paymentInfo: {},
                loading : true
            };
        case actions.FETCH_PAYMENT_SUCCEEDED:
            return {
                ...state,
                paymentInfo: action.payment,
                loading     : false
            };
        case actions.FETCH_PAYMENT_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
